export type InvoiceType = 'PLATFORM_COMMISSION';

export const INVOICE_TYPE_LABELS: Record<InvoiceType, string> = {
  PLATFORM_COMMISSION: 'Comisión plataforma → propietario',
};

export interface AdminInvoiceListItem {
  id: string;
  type: InvoiceType;
  invoiceNumber: string;
  issueDate: string;
  bookingId: string;
  spaceName?: string;
  recipientLegalName: string;
  totalCents: number;
  createdAtMs: number | null;
}

export interface GenerateBookingInvoicesResult {
  results: Array<{
    type: InvoiceType;
    invoiceId?: string;
    invoiceNumber?: string;
    skipped?: boolean;
  }>;
}

export interface RepairMissingInvoicesResult {
  scanned: number;
  pending: number;
  created: number;
  relinked: number;
  skipped: number;
  failed: number;
  failures: Array<{ bookingId: string; reason: string }>;
}
